// extracted by mini-css-extract-plugin
module.exports = {"consentBanner":"ConsentDialog_consentBanner__3I4sX","consentDialog":"ConsentDialog_consentDialog__eIso3"};